import { FC } from 'react';
import {
  getTruncateMaxLinesStyle,
  WbTooltip,
} from '@agilelab/plugin-wb-platform';
import { Theme, Typography, makeStyles } from '@material-ui/core';

type ValidationTitleProps = {
  name: string;
  important?: boolean;
};

const useStyles = makeStyles<Theme, { important: boolean | undefined }>(
  () => ({
    root: ({ important }) => ({
      fontWeight: important ? 700 : undefined,
      ...getTruncateMaxLinesStyle(1, false),
    }),
  }),
  { name: 'ValidationTitle' },
);

export const ValidationTitle: FC<ValidationTitleProps> = ({
  important,
  name,
}) => {
  const classes = useStyles({ important });
  return (
    <WbTooltip title={name}>
      <Typography
        variant={important ? 'body1' : 'body2'}
        className={classes.root}
      >
        {name}
      </Typography>
    </WbTooltip>
  );
};
